<template>
  <div class="text-sm rounded-lg w-full cursor-default border-[1px] border-gray-200 mt-4">
    <button
      @click="timelineToggle = !timelineToggle"
      class="font-semibold flex items-center justify-between w-full hover:bg-gray-100 transition-all duration-200 p-4"
    >
      <div class="flex items-center">
        <CalendarDays class="w-4 h-4 mr-2 transition-transform duration-200" />
        <span>Timeline</span>
      </div>
      <ChevronDown
        class="w-4 h-4 transition-transform duration-200"
        :style="{ transform: timelineToggle ? 'rotate(180deg)' : 'rotate(0deg)' }"
      />
    </button>

    <!-- Timeline form -->
    <transition
      enter-active-class="transition-all duration-300 ease-out"
      leave-active-class="transition-all duration-300 ease-in"
      enter-from-class="transform opacity-0 max-h-0"
      enter-to-class="transform opacity-100 max-h-[1000px]"
      leave-from-class="transform opacity-100 max-h-[1000px]"
      leave-to-class="transform opacity-0 max-h-0"
    >
      <div v-if="timelineToggle" class="px-4 pb-2">
        <Form v-model="timelineForm" class="w-full p-2 space-y-4">
          <div class="grid grid-cols-2 gap-4">
            <FormField name="date_referral_requested">
              <FormItem>
                <FormLabel>Referral requested</FormLabel>
                <FormControl>
                  <DatePicker v-model="timelineForm.date_referral_requested" />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>

            <FormField name="date_referral_confirmed">
              <FormItem>
                <FormLabel>Referral confirmed</FormLabel>
                <FormControl>
                  <DatePicker v-model="timelineForm.date_referral_confirmed" />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>

            <FormField name="date_coding_test">
              <FormItem>
                <FormLabel>Coding test</FormLabel>
                <FormControl>
                  <DatePicker v-model="timelineForm.date_coding_test" />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>

            <FormField name="date_first_call">
              <FormItem>
                <FormLabel>First call</FormLabel>
                <FormControl>
                  <DatePicker v-model="timelineForm.date_first_call" />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>

            <FormField name="date_onsite_invited">
              <FormItem>
                <FormLabel>Onsite invited</FormLabel>
                <FormControl>
                  <DatePicker v-model="timelineForm.date_onsite_invited" />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>

            <FormField name="date_onsite_result">
              <FormItem>
                <FormLabel>Onsite result</FormLabel>
                <FormControl>
                  <DatePicker v-model="timelineForm.date_onsite_result" />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>

            <FormField name="date_offer_received">
              <FormItem>
                <FormLabel>Offer received</FormLabel>
                <FormControl>
                  <DatePicker v-model="timelineForm.date_offer_received" />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>

            <FormField name="date_offer_signed">
              <FormItem>
                <FormLabel>Offer signed</FormLabel>
                <FormControl>
                  <DatePicker v-model="timelineForm.date_offer_signed" />
                </FormControl>
                <FormMessage />
              </FormItem>
            </FormField>
          </div>
        </Form>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { CalendarDays, ChevronDown } from 'lucide-vue-next'
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage
} from '@/components/ui/form'
import DatePicker from '@/components/ui/date-picker/DatePicker.vue'

const props = defineProps<{
  modelValue: {
    date_offer_signed?: Date
    date_offer_received?: Date
    date_onsite_result?: Date
    date_onsite_invited?: Date
    date_first_call?: Date
    date_coding_test?: Date
    date_referral_confirmed?: Date
    date_referral_requested?: Date
  }
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: typeof props.modelValue): void
}>()

const timelineToggle = ref(false)

const timelineForm = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})
</script> 